/**
 * 报表管理
*/
import http from '@/request/http'
export default {
  /******   自定义报表   *****/
  // 获取表格数据
  formGetTabData: params => http.post(`/api/report/getReportContentList`, params),
  // 保存模板
  formAddReport: params => http.post(`/api/report`, params),
  /******   报表模板   *****/
  // 获取模板列表
  formGetReportList: params => http.get(`/api/getReportList`, params),
  // 删除模板
  formDeleteItem: (params, id) => http.delete(`/api/report/${id}`, params),
  /******   能耗报表   *****/

  formECOverview: params => http.get(`/api/report/energyConsumption/getEnergyConsumptionOverview`, params),// 能耗总览
  formECConservation: params => http.get(`/api/report/energyConsumption/getReduce`, params), // 节能减排
  formECPhotovoltaic: params => http.get(`/api/report/energyConsumption/getPhotovoltaics`, params), // 光伏发电量
  formDataEC: params => http.get(`/api/report/energyConsumption/getEnergyConsumptionRanking`, params), //区域部门系统能耗

/******   运维报表   *****/
formDevOpsAlarmSystem: params => http.get(`/api/juji/alarm/getAlarmAnalysisByAsset`, params), // 报警系统
formDevOpsMaintenanceInspection: params => http.get(`/api/odoo/inspectionTask/task/getMaintenanceReportForms`, params), // 巡检/保养数据
formDevOpsInspectionCharts: params => http.get(`/api/odoo/inspectionTask/task/getInspectionReportForms`, params), // 巡检饼图



  getDeviceParameter: params => http.get(`/api/plugins/telemetry/findListByProjectId`, params),//获取 自定义参数
  getAssetTreeByParameter: params => http.get(`/api/juji/relation/customTelemetryProperties`, params),//根据属性 获取资产



}

